import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ObjectAssociationsManyToManyIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ObjectAssociationsManyToMany",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.34 19.34c.06 0 .11-.02.17-.06l4.38-3.27c.12-.1.15-.27.06-.4-.03-.03-.04-.04-.08-.06l-4.38-2.82a.29.29 0 0 0-.39.09c-.04.04-.04.1-.04.15v1.42c0 .15-.12.27-.27.28h-3.74V7.74l3.74.03c.15 0 .27.12.27.27v1.39c0 .15.12.28.28.28.06 0 .11-.02.17-.06l4.38-3.27c.12-.1.15-.27.06-.4-.03-.03-.04-.04-.08-.06L25.49 3.1a.29.29 0 0 0-.39.09c-.04.04-.04.1-.04.15v1.42c0 .15-.12.27-.27.28h-6c-.22 0-.4.17-.4.4v9.25h-4.9V5.43c0-.23-.18-.41-.4-.41H2.31c-.17 0-.3.14-.3.31v2.11c0 .17.13.3.31.3l8.53-.02v6.92H2.31c-.17 0-.3.14-.3.31v2.11c0 .17.13.31.31.3l8.53-.02v6.92H2.3c-.17 0-.3.14-.3.31v2.12c0 .17.13.3.3.3l8.93-.02h1.85c.22 0 .41-.19.41-.41V17.3h4.9v9.26c0 .22.19.41.41.41h1.85l4.13.03c.16 0 .28.12.28.27v1.39c0 .15.12.28.27.28.06 0 .12-.03.18-.06l4.38-3.27c.12-.1.15-.27.06-.4-.03-.03-.05-.04-.08-.06l-4.39-2.82a.28.28 0 0 0-.38.09c-.04.04-.04.1-.04.15v1.42c0 .15-.12.27-.28.28h-3.73v-6.93l3.74.03c.15 0 .27.12.27.27v1.39c0 .15.12.28.28.28v.02Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M27.29 31.86c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l2.62-2.62-2.62-2.62a1.14 1.14 0 0 1 0-1.62 1.15 1.15 0 0 1 1.62 0l3.43 3.43c.45.45.45 1.17 0 1.62l-3.43 3.43c-.22.22-.52.33-.81.33"
      }), /*#__PURE__*/_jsx("path", {
        d: "M30.71 28.43H17c-.63 0-1.14-.51-1.14-1.14V4.43c0-.63.51-1.14 1.14-1.14h13.71a1.14 1.14 0 1 1 0 2.28H18.14v20.57h12.57a1.14 1.14 0 1 1 0 2.28ZM7.86 28.43H1a1.14 1.14 0 1 1 0-2.28h5.71V5.57H1a1.14 1.14 0 1 1 0-2.28h6.86C8.49 3.29 9 3.8 9 4.43v22.86c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M27.29 9c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l2.62-2.62-2.62-2.62a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l3.43 3.43c.45.45.45 1.17 0 1.62L28.1 8.67c-.22.22-.52.33-.81.33M30.71 17H1a1.14 1.14 0 1 1 0-2.28h29.71a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M27.29 20.43c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l2.62-2.62-2.62-2.62a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l3.43 3.43c.45.45.45 1.17 0 1.62L28.1 20.1c-.22.22-.52.33-.81.33"
      })]
    })
  }));
};
ObjectAssociationsManyToManyIcon.displayName = 'ObjectAssociationsManyToManyIcon';